var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("BoxWrap", { attrs: { "no-title": true } }, [
        _c(
          "div",
          { attrs: { slot: "footer-right" }, slot: "footer-right" },
          [
            _c(
              "el-button",
              {
                attrs: { size: "small", icon: "el-icon-refresh" },
                on: { click: _vm.resetTableList },
              },
              [_vm._v(_vm._s(_vm.$t("common.reset")))]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "t-search-btn",
                attrs: { size: "small", icon: "el-icon-search" },
                on: { click: _vm.queryFetch },
              },
              [_vm._v(_vm._s(_vm.$t("common.search")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "action-container" },
          [
            _c(
              "el-form",
              { attrs: { size: "small", inline: "", "label-position": "top" } },
              [
                _c(
                  "el-row",
                  { attrs: { type: "flex" } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SRStoreList.form.province"),
                              required: true,
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  "value-key": "value",
                                  clearable: "",
                                  placeholder: _vm.$t("common.pleaseSelect"),
                                },
                                on: { change: _vm.provinceChange },
                                model: {
                                  value: _vm.regionObj,
                                  callback: function ($$v) {
                                    _vm.regionObj = $$v
                                  },
                                  expression: "regionObj",
                                },
                              },
                              _vm._l(_vm.regionOptions, function (proviceItem) {
                                return _c("el-option", {
                                  key: proviceItem.value,
                                  attrs: {
                                    label: proviceItem.label,
                                    value: proviceItem,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 7, offset: 1 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SRStoreList.form.city"),
                              required: true,
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  "value-key": "value",
                                  clearable: "",
                                  placeholder: _vm.$t("common.pleaseSelect"),
                                },
                                model: {
                                  value: _vm.cityObj,
                                  callback: function ($$v) {
                                    _vm.cityObj = $$v
                                  },
                                  expression: "cityObj",
                                },
                              },
                              _vm._l(_vm.cityOptions, function (cityItem) {
                                return _c("el-option", {
                                  key: cityItem.value,
                                  attrs: {
                                    label: cityItem.label,
                                    value: cityItem,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.tab === "carpacTab2"
                      ? _c(
                          "el-col",
                          { attrs: { span: 7, offset: 1 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("sfe.reportModule.rimSize"),
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: _vm.$t("common.pleaseInput"),
                                    autocomplete: "off",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.rimSize,
                                    callback: function ($$v) {
                                      _vm.rimSize =
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                    },
                                    expression: "rimSize",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _vm.tab === "carpacTab2"
                      ? _c(
                          "el-col",
                          { attrs: { span: 7 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("sfe.reportModule.rim"),
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      clearable: "",
                                      placeholder: _vm.$t(
                                        "common.pleaseSelect"
                                      ),
                                    },
                                    model: {
                                      value: _vm.rim,
                                      callback: function ($$v) {
                                        _vm.rim = $$v
                                      },
                                      expression: "rim",
                                    },
                                  },
                                  _vm._l(_vm.rimList, function (item) {
                                    return _c("el-option", {
                                      key: item.code,
                                      attrs: {
                                        label: item.name,
                                        value: item.code,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "BoxWrap",
        { staticClass: "main-table-container", attrs: { "no-title": true } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _vm.tab === "carpacTab1"
                ? [
                    _c("el-table-column", {
                      attrs: {
                        prop: "carparc",
                        label: _vm.$t("sfe.reportModule.carparcText"),
                        align: "left",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  _vm._s(_vm.paddingNum(scope.row.carparc))
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2232654987
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "rimCarparc",
                        label: _vm.$t("sfe.reportModule.plus18"),
                        align: "left",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  _vm._s(_vm.paddingNum(scope.row.rimCarparc))
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4234685405
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "rimPercent",
                        label: _vm.$t("sfe.reportModule.plus18Percent"),
                        align: "left",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [_vm._v(_vm._s(scope.row.rimPercent))]
                            },
                          },
                        ],
                        null,
                        false,
                        252674640
                      ),
                    }),
                  ]
                : _vm.tab === "carpacTab2"
                ? [
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("sfe.reportModule.sequence"),
                        width: "80",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    (_vm.currPage - 1) * _vm.limit +
                                      scope.$index +
                                      1
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "rimSize",
                        label: _vm.$t("sfe.reportModule.rimSize"),
                        align: "left",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "rimCarparc",
                        label: _vm.$t("sfe.reportModule.rimCarparc"),
                        align: "left",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(_vm.paddingNum(scope.row.rimCarparc))
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: {
                          label: _vm.$t("sfe.reportModule.top5"),
                          align: "center",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            label: "1",
                            align: "left",
                            "show-overflow-tooltip": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.details[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "2",
                            align: "left",
                            "show-overflow-tooltip": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.details[1])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "3",
                            align: "left",
                            "show-overflow-tooltip": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.details[2])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "4",
                            align: "left",
                            "show-overflow-tooltip": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.details[3])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "5",
                            align: "left",
                            "show-overflow-tooltip": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.details[4])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm.tab === "carpacTab3"
                ? [
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("sfe.reportModule.sequence"),
                        width: "80",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    (_vm.currPage - 1) * _vm.limit +
                                      scope.$index +
                                      1
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "brandModel",
                        label: _vm.$t("sfe.reportModule.mainCarType"),
                        width: "200",
                        align: "left",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "rimCarparc",
                        label: _vm.$t("sfe.reportModule.rimCarparc"),
                        width: "200",
                        align: "left",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(_vm.paddingNum(scope.row.rimCarparc))
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("sfe.reportModule.rimSize"),
                        align: "left",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return _vm._l(scope.row.details, function (item) {
                              return _c(
                                "span",
                                { key: item, staticClass: "mr_40" },
                                [_vm._v(_vm._s(item))]
                              )
                            })
                          },
                        },
                      ]),
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }